'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './compliance.routes';

export class ComplianceComponent {
  /*@ngInject*/
  constructor($scope, $http, userService, baseConfigService, fetch, $state, $location, $timeout) {
    this.$scope = $scope;
    this.$http = $http;
    this.$state = $state;
    this.fetch = fetch;
    this.$location = $location;
    this.$timeout = $timeout;

    // Services 
    this.userService = userService;
    this.baseConfigService = baseConfigService;
    $scope.baseUrl = baseConfigService.getBaseURL();

    // Initialize rowCollection and filteredCollection
    $scope.rowCollection = [];
    $scope.filteredCollection = [];

    
     // Function to group submissions by jurisdiction and station area
     $scope.groupSubmissions = function (submissions) {
      const grouped = {};

      submissions.forEach(submission => {
          const key = `${submission.jurisdiction}|${submission.station_name}`;

          if (!grouped[key]) {
              grouped[key] = {
                  jurisdiction: submission.jurisdiction,
                  station_name: submission.station_name,
                  count: 0,
                  submissions: [], // Store all submissions in this group
                  status: 'In Review' // Default status
              };
          }

          grouped[key].count += 1; // Increment the count for this group
          grouped[key].submissions.push(submission); // Add submission to the group
      });

      // Calculate the status for each group
      Object.values(grouped).forEach(group => {
          const statuses = group.submissions.map(sub => sub.status);
          if (statuses.every(status => status === statuses[0])) {
              group.status = statuses[0]; // All submissions have the same status
          } else {
              group.status = 'In Review'; // Submissions have different statuses
          }
      });

      return Object.values(grouped); // Convert grouped object to an array
  };

    // Function to group submissions by jurisdiction and station area
    $scope.groupSubmissions = function (submissions) {
        const grouped = {};

        submissions.forEach(submission => {
            const key = `${submission.jurisdiction}|${submission.station_name}`;

            if (!grouped[key]) {
                grouped[key] = {
                    jurisdiction: submission.jurisdiction,
                    station_name: submission.station_name,
                    count: 0
                };
            }

            grouped[key].count += 1; // Increment the count for this group
        });

        return Object.values(grouped); // Convert the grouped object to an array
    };

      // Define the filterTable function
    $scope.filterTable = function (policyType) {
        switch (policyType) {
            case 'Density':
                $scope.filteredCollection = $scope.groupSubmissions($scope.densitySubmissions);
                break;
            case 'Housing Policies':
                $scope.filteredCollection = $scope.groupSubmissions($scope.housingSubmissions);
                break;
            case 'Parking':
                $scope.filteredCollection = $scope.groupSubmissions($scope.parkingSubmissions);
                break;
            case 'Station Area Access':
                $scope.filteredCollection = $scope.groupSubmissions($scope.stationAreaAccessSubmissions);
                break;
            default:
                $scope.filteredCollection = $scope.groupedCollection; // Show all submissions by default
        }
    };

  }

  $onInit() {
    this.userService.getCurrentUser()
    .then(response => {
       
      this.$scope.currentUser = response.data;
      this.userService.setCurrentUser(response.data);
    })
    .catch(err => {
      console.log(err);
      if(err.status === 403){
        this.$state.go('login');
      }
    })
        // Fetch submission summary data
        this.fetch.getAllItems(`api/data/submissions/get-submission-summary`)
        .then(response => {

            console.log(response);
            this.$scope.rowCollection = response.data;
            this.$scope.groupedCollection = this.$scope.groupSubmissions(response.data); // Group data
            this.$scope.filteredCollection = [].concat(this.$scope.groupedCollection); // Initialize filteredCollection
        })
        .catch(err => {
            console.log(err);
        });

    // Fetch all submissions data
    this.fetch.getAllItems(`api/data/submissions/get-submissions`)
        .then(response => {
            console.log(response);
            this.$scope.rowCollection = response.data; // Bind data to rowCollection

            // Filter submissions by policy type
            const submissions = response.data;
            const housingPolicyTypes = [
                'Housing Commercial Policy',
                'Housing Production Policy',
                'Housing Preservation Policy',
                'Commercial Stabilization Policy'
            ];

            this.$scope.housingSubmissions = _.filter(submissions, (submission) =>
                housingPolicyTypes.includes(submission.submission_policy_type)
            );
            this.$scope.densitySubmissions = _.filter(submissions, { submission_policy_type: 'Density' });
            this.$scope.parkingSubmissions = _.filter(submissions, { submission_policy_type: 'Parking' });
            this.$scope.stationAreaAccessSubmissions = _.filter(submissions, { submission_policy_type: 'Station Area Access' });
            this.$scope.zoningUpdatesSubmissions = _.filter(submissions, { submission_policy_type: 'Jurisdiction Zoning Updates' });

            // Group the data
            this.$scope.groupedCollection = this.$scope.groupSubmissions(response.data);

            // Initialize filteredCollection to show all submissions by default
            this.$scope.filteredCollection = [].concat(this.$scope.groupedCollection);
        })
        .catch(err => {
            console.log(err);
        });
      }
  }

export default angular.module('appApp.compliance', [uiRouter, 'smart-table'])
  .config(routes)
  .component('compliance', {
    template: require('./compliance.html'),
    controller: ComplianceComponent,
    controllerAs: 'complianceCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/compliance/compliance.component.js